<template>
  <div>
    <FloatingCartBox
      v-if="currentProject && currentProject.id && cartSettings && cartSettings.cart_enabled && !isSingleMode"
      :currentProject="currentProject"
      :totalIncentive="totalIncentive"
      :pageConfiguration="pageConfiguration"
    />
    <div class="row">
      <div class="col-12">
        <div :class="['card', { 'no-card': disableCard }]">
          <div :class="['card-body', { 'no-card': disableCard }]">
            <span class="egx-partner-color">
              <h1 class="">{{ header.title }}</h1>
            </span>
            <div v-safe-html="header.description" />
            <Step :content="currentStepContent" :step="step" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Step from './Step.vue';
import Dialog from '@/components/Dialog.vue';
import FloatingCartBox from '@/components/FloatingCartBox.vue';
import mockData from '../mockData';
export default {
  components: {
    Step,
    Dialog,
    FloatingCartBox,
  },
  props: {
    stepNum: Number,
    mode: String,
  },
  data() {
    return {
      header: mockData.header,
      stepContent: mockData.stepContent,
      disableCard: true,
      step: this.stepNum,
      showModal: false,
      cartItems: [],
      totalIncentive: null,
      pageConfiguration: {},
    };
  },

  created() {
    this.$store.dispatch('fulfill_integrate/getPageConfiguration', {
      task_name: 'measurecart',
      project_id: this.$route.params.id,
    })
    .then((response) => {
      this.pageConfiguration = response;
    })
    .catch((error) => {
      console.log(error);
    })
  },

  computed: {
    currentStepContent() {
      return this.stepContent[this.step - 1];
    },
    currentProject() {
      return this.$store.state.fulfill_integrate.currentSelectedProject;
    },
    cartSettings() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details.settings.project_measures_cart || {};
    },

    isSingleMode() {
      return this.mode === 'single';
    }
  },
  watch: {
    '$route.query.step': {
      immediate: true,
      handler(newStep) {
        this.step = parseInt(newStep);
      }
    }
  },
}
</script>

<style scoped>
.no-card {
  border: none;
  box-shadow: none;
  padding: 0;
  margin: 0;
}
</style>
